import React from "react";
import { useState, useEffect } from "react";
import "./ProposalPublic.scss";
import { useRouteMatch } from "react-router-dom";
import clientAxios from "../../config/axios";
import { PhoneLogo, EmailLogo } from "../../assets";
import LoaderDots from "../generalComponents/LoaderDots";
import { images } from "../../constants";
import CardContainer from "./proposalPublic/CardContainer";
import CardCollegePublic from "./proposalPublic/CardCollegePublic";
import CardInsurancePublic from "./proposalPublic/CardInsurancePublic";
import CardVisaPublic from "./proposalPublic/CardVisaPublic";
import { numberNotation } from "../../helper/numberStructure";
import SocialMediaPublic from "./proposalPublic/SocialMediaPublic";
import {
  minimumPayment,
  totalCoursesPrice,
  totalInsurancePrice,
  totalProposalPrice,
  totalVisaPrice,
} from "../../helper/ProposalCalc";

const ProposalPublic = () => {
  const [data, setData] = useState(null);
  // const {studentSelected, coursesSelected} = data
  // const [totalprices, setTotalprices] = useState(null);

  const { params } = useRouteMatch();
  // const link = process.env.REACT_APP_PROPOSAL_URL
  // const link = "http://localhost:3009/api/v1/proposals/";
  const serverLink = process.env.REACT_APP_BACKEND_ORIGO_URL
  // const server = `https://origo.up.railway.app`
  const link = `${serverLink}/api/v1/proposals/`;
  const url = `${link}${params.id}`;

  const getPublicProposal = async () => {
    try {
      const result = await clientAxios.get(url);
      const dataproposal = result.data.proposal[0];
      setData(dataproposal);
    } catch (error) {
      console.log("user not foud");
    }
  };

  useEffect(() => {
    getPublicProposal();
    //eslint-disable-next-line
  }, [url]);

  if (data === null || !data) {
    return (
      <div className="Loader-page">
        <LoaderDots />
      </div>
    );
  }

  const visaTotal = totalVisaPrice(data);
  const insuranceTotal = totalInsurancePrice(data);

  const minimumPay = minimumPayment(data);
  const totalCourses = totalCoursesPrice(data);

  const totalProposal = totalProposalPrice(data);

  return (
    <div>
      <div className="main-header">
        <header className="header">
          <div className="header__logo">
            <a
              href="https://en.multi-edu.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={images.logoMeWhite} alt="" />
            </a>
          </div>
          <ul className="header__nav--list">
            <li className="header__nav--list-item">
              <img src={PhoneLogo} alt="wt" />
              <p className="title-grey-16-regular">+61 466 910 565</p>
            </li>
            <li className="header__nav--list-item">
              <img src={EmailLogo} alt="wt" />
              <p className="title-grey-16-regular">marketing@multi-edu.com</p>
            </li>
          </ul>
        </header>
        <div className="hero-text">
          <h1 className="title-white-bold-29">
            Hi,{" "}
            <span style={{ fontWeight: "900", fontSize: "38px" }}>
              {data.studentSelected.studentname}
            </span>{" "}
            your Australian journey starts here.
          </h1>
        </div>
        <div className="hero_bubbles">
          <img src={images.BubblesPublic} alt="" />
        </div>
        <div className="hero-price">
          <h2 className="title-gray-bold-26 ">Minimum Payment</h2>
          <h2 className="title-gray-black-32">
            <span className="paragraph-gray-reg-16">$A</span>
            {numberNotation(minimumPay)}
          </h2>

          <div className="hero-price__total">
            <h2 className="title-gray-bold-16 ">Total Payment</h2>
            <h2 className="title-gray-bold-20">
              <span className="paragraph-gray-reg-14">$A</span>
              {numberNotation(totalProposal)}
            </h2>
          </div>
        </div>
      </div>

      <div className="help-message">
        <p className="paragraph-gray-reg-20"> This payment includes</p>
      </div>

      <main className="quote">
        <ul className="quote__public-list">
          <CardContainer title={`Educational`} total={totalCourses}>
            <CardCollegePublic />
            {data.coursesSelected?.map((course) => (
              <CardCollegePublic key={course._id} course={course} />
            ))}
          </CardContainer>

          <CardContainer title={`Insurance`} total={insuranceTotal}>
            {data.insuranceSelected?.map((insurance) => (
              <CardInsurancePublic key={insurance._id} insurance={insurance} />
            ))}
          </CardContainer>

          <CardContainer title={`Visa`} total={visaTotal}>
            {data.visaSelected?.map((visa) => (
              <CardVisaPublic key={visa._id} visa={visa} />
            ))}
          </CardContainer>
        </ul>
      </main>

      <div className="note-container">
        <div className="note-container__wrapper">
          <h2 className="title-gray-bold-26">Note:</h2>
          <p className="paragraph-gray-reg-20">
            {data.noteSelected.description}
          </p>
        </div>
      </div>

      <footer className="footer">
        <div className="footer__bg">
          <img src={images.FooterBg} alt="" />
        </div>
        <h1 className="footer__title title-white-bold-24 over-bg">
          Get in Touch
        </h1>

        <div className="footer__links over-bg">
          <SocialMediaPublic />
        </div>

        <div className="footer__information">
          <div className="title-grey-18-regular over-bg ">
            <p>Level 7 - 222 Exhibition Street</p>
            <p> Melbourne - VIC 3000</p>
          </div>

          <div className="contact-tel over-bg">
            <span className="title-grey-18-regular">+61 466 910 565</span>
            <p className="title-grey-16-regular">marketing@multi-edu.com</p>
          </div>

          <div className="footer__powered over-bg">
            <span className="paragraph-white-reg-14 powered-by">
              powered by
            </span>
            <div className="logo-container">
              <img src={images.logoMeWhite} alt="logo me" />
            </div>
          </div>
        </div>

        <div className="footer__developer">
          <p>Developed by </p>
          <a
            href="https://www.sebastianto.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="title-grey-18-regular"
          >
            <div className="footer__developer--logo">
              <img src={images.Seb} alt="" />
            </div>
          </a>
        </div>
      </footer>
    </div>
  );
};

export default ProposalPublic;
